import {Logger} from '../../plugins/logger';
import moment from 'moment';

const log = Logger.get('auth-bind');

let timeoutId;

function runAtMidnight(run) {
  const now = moment();
  const night = moment().add(1, 'day').startOf('day');
  const msToMidnight = night.valueOf() - now.valueOf();

  clearTimeout(timeoutId);
  timeoutId = setTimeout(() => {
    run();
    runAtMidnight(run);
  }, msToMidnight);
}

export default store => {
  log.info('running...');

  store.dispatch('auth/bind')
      .catch(err => log.error('Failed to bind the server ', err));

  // when authenticated, bind feeds
  store.watch(
      (state, getters) => getters['auth/isAuthenticated'],
      auth => {
        if (auth) {
          store.dispatch('user/getUserDoc')
              .then(() => {
                store.dispatch('user/getLinkedUserDoc')
                    .catch(err => log.error('Failed to getLinkedUserDoc', err));

                store.dispatch('feeds/bindLatest')
                    .catch(err => log.error('Failed to bind latest', err));

                store.dispatch('feeds/bindToday')
                    .catch(err => log.error('Failed to bind today', err));
              })
              .catch(err => log.error('Failed to get user doc', err));

          runAtMidnight(() => {
            store.dispatch('feeds/bindToday')
                .catch(err => log.error('Failed to re-bind today', err));
          });
        }
      }
  );
}
